<template>
  <div class="all-wrap">
    <div class="tabs">
      <div
        v-for="(item,index) in tabList"
        :key="index"
        :class="'tab-item ' + (currentIndex===index?'tab-item-active ':'')"
        @click="changeStatus(index)"
      >{{item.name}}</div>
    </div>
    <!-- 列表内容 -->
    <div class="coupon-list" v-if="dataList&&dataList.length">
      <dl :class="currentIndex === 3?'gray':'orange'" v-for="data in dataList"
        :key="currentIndex===0?data.id : data.couponUserId">
        <dt>
          <p class="price">
            <!-- <span>￥</span> -->
            <!-- {{data.amount}} -->
            {{data.name}}
          </p>
          <p class="minus" v-if="data.type === 0">满{{data.mjAmount}}减{{data.amount}}</p>
          <p class="minus" v-else>立减{{data.amount}}</p>

          <p v-if="currentIndex === 0" class="expire orange-font">
            领用时间：{{data.startTime}}~{{data.endTime}}
          </p>
          <p v-if="currentIndex === 0 && data.effectiveType === 0" class="expire orange-font">
            使用期限：{{data.effectiveStartTime}}~{{data.effectiveEndTime}}
          </p>
          <p v-else-if="currentIndex === 0 && data.effectiveType === 1" class="expire orange-font">
            使用期限：领取后30天内使用
          </p>

          <p v-else-if="currentIndex !== 0" class="expire" :class="currentIndex === 3?'gray-font':'orange-font'">
            使用期限：{{data.effectiveStartTime}}~{{data.effectiveEndTime}}
          </p>
          <!-- <p class="expire orange-font">
            优惠券名称：{{data.name}}
          </p> -->
           <!-- <p v-show="currentIndex === 1 && data.effectiveType === 0"
            class="expire"
            :class="currentIndex === 3?'gray-font':'orange-font'"
          >使用期限：{{data.effectiveStartTime}}~{{data.effectiveEndTime}}</p>
          <p v-show="currentIndex === 1 && data.effectiveType === 1"
            class="expire"
            :class="currentIndex === 3?'gray-font':'orange-font'"
          >使用期限：领取后30天内使用</p> -->
        </dt>
        <dd>
          <p class="scope">
            <el-tooltip popper-class="popper-class"  effect="dark"  placement="bottom">
              <span class="ell-two">适用范围：{{data.scopeTypeStr}}
                <span v-if="data.scopeType === 0">全部</span>
                <span v-else-if="data.scopeType === 3">全部课程</span>
                <span v-else-if="data.scopeType === 4">全部图书</span>
              </span>
              <div slot="content" style="max-width:180px;">
                <span class="">适用范围：{{data.scopeTypeStr}}
                <span v-if="data.scopeType === 0">全部</span>
                <span v-else-if="data.scopeType === 3">全部课程</span>
                <span v-else-if="data.scopeType === 4">全部图书</span>
              </span>
              </div>
              </el-tooltip>

          </p>
          <p class="get" v-if="currentIndex=== 0 && (data.limitType === 0 ? true : Number(data.remainedCount)> 0)" @click="getCoupon(data.id)">立即领取 <img class="arrow" src="~@/assets/img/imgarrow_03.png"/></p>
          <p class="none" v-else-if="currentIndex=== 0 && data.limitType === 1 && data.remainedCount=== 0">已领完</p>
          <p class="get" v-else-if="currentIndex=== 1 && data.canUse" @click="handleUse">立即使用 <img class="arrow" src="~@/assets/img/imgarrow_03.png"/></p>
          <p class="get" v-else-if="currentIndex=== 1 && !data.canUse">未到使用时间</p>
          <!-- <p class="get" v-show="data.canReceive && data.status=== 0" @click="getCoupon(data.id)">立即领取 <img class="arrow" src="~@/assets/img/imgarrow_03.png"/></p>
          <p class="none" v-show="!data.canReceive && data.status=== 0">已领完</p>
          <p class="get" v-show="data.canUse && data.status=== 1" @click="handleUse">立即使用 <img class="arrow" src="~@/assets/img/imgarrow_03.png"/></p>
          <p class="get" v-show="!data.canUse && data.status=== 1">未到使用时间</p> -->
          <!-- 已使用 / 已过期 -->
          <!-- 优惠券的状态值改为 1:未使用,2:已使用,3已过期 -->
          <div
            v-show="currentIndex === 2 || currentIndex ===3"
            class="used"
            :class="currentIndex === 2?'already-used':'expired'"
          ></div>
        </dd>
      </dl>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img src="@/assets/img/good/noGood.png" alt="暂无数据">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tabList: [
        {
          name: '未领取',
          show: false
        },
        {
          name: '未使用',
          show: false
        },
        {
          name: '已使用',
          show: true
        },
        {
          name: '已过期',
          show: true
        }
      ],
      currentIndex: 0,
      dataList: [],
      tooltip: '' // 提示文案
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    changeStatus (index) {
      this.currentIndex = index
      this.getDataList()
    },
    getDataList () {
      this.dataList = []
      // this.$http.get(`${window.SITE_CONFIG["trainURL"]}/coupon/traincouponuserdetail/selectMyCouponList`,
      this.$http.post(`/front/train/trainCoupon/selectGetYetCoupons`,
        {
          status: this.currentIndex
        }
      )
        .then(data => {
          if (data.data.code === 0) {
          // console.log(data)
            this.dataList = data.data.data
          } else {
            this.$message.error(data.data.msg)
          }
        })
    },
    // 领取优惠券
    getCoupon (id) {
      // this.$http.get(`${window.SITE_CONFIG["trainURL"]}/coupon/traincouponuserdetail/getTheCoupon/` + id)
      this.$http.post(`/front/train/trainCouponUserDetail/getTheCoupon/${id}`)
        .then(data => {
          if (data.data.code === 0) {
            this.getDataList()
            this.$message.success('领取成功')
          } else {
            this.$message.error(data.data.msg)
          }
        })
    },
    // 立即使用跳转首页
    handleUse () {
      this.$router.push({ name: 'onlineTraining' })
    }
  }
}
</script>
<style scoped>
.ell-two{
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	display: -webkit-box;
}
.myAsk {
  width: 80px;
  text-align: center;
  float: left;
}
.coupon-list {
  margin-left: 69px;
  /* width: 100%; */
  height: auto;
  /* background: pink; */
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.coupon-list dl {
  background-color: #fff;
  position: relative;
  width: 200px;
  margin-right: 20px;
  margin-bottom: 20px;
  text-align: center;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.04);
  padding-bottom: 40px;

}
.coupon-list dl dt {
  width: 100%;
  height: 157px;
  padding-top: 15px;
  text-align: center;
}
.coupon-list dl dd {
  background: #fff;
  min-height: 40px;
  margin: 0;
  text-align: center;
  cursor: pointer;
}
.coupon-list dl dt p.price {
  color: #f5f5f5;
  font-size: 18px;
    margin: 10px 0 0;
}
.coupon-list dl dt p.price span {
  margin-top: 5px;
}
.coupon-list dl dt p.minus {
  color: #f5f5f5;
    margin: 0;
  /* margin-top: 3px; */
}
.coupon-list dl dt p.expire {
  margin-top: 12px;
  font-size: 12px;
  margin-bottom: 0;
}
.coupon-list dl dd p.scope {
  margin: 15px 0;
  padding: 0 10px;
  font-size: 12px;
}
.coupon-list dl dd p.scope span {
  color: #999;
}
.coupon-list dl dd p.get {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #e62614;
  cursor: pointer;
  text-align: center;
  width: 100%;
  z-index: 999;
  line-height: 40px;
}
div.used {
  width: 67px;
  height: 50px;
  position: absolute;
  bottom: 10px;
  right: 0;
}
/* 已使用 */
.already-used {
  background: url("~@/assets/img/已使用.png") no-repeat;
}
/* 已过期 */
.expired {
  background: url("~@/assets/img/已过期.png") no-repeat;
}
.orange {
  background: url("~@/assets/img/coupon_bg_red.png") no-repeat;
  background-size: 200px 160px;
  /* background-position-x: -20px; */
}
.gray {
  background: url("~@/assets/img/coupon_bg_grey.png") no-repeat;
  background-size: 200px 160px;
  /* background-position-x: -20px; */
}
.orange-font {
  color: #93231b;
}
.gray-font {
  color: #7e7e7e;
}
.none{
  font-size: 12px;
  color: #e62614;
}
.arrow{
  width:17px;
}

</style>
<style lang="scss">
.popper-class{
  background: #6a6a6d!important;
  color: #fff;
  border-color: #6a6a6d;
}
.popper__arrow:after{
  border-bottom-color: #747574!important;
  border-top-color: #747574!important;
}
</style>
